export default () => [
  // {
  //   field: 'seq',
  //   width: 40,
  //   align: 'center',
  //   fixed: 'left',
  //   type: 'seq',
  // },
  // {
  //   field: 'col-opt',
  //   title: '操作',
  //   headerAlign: 'center',
  //   align: 'left',
  //   width: 90,
  //   fixed: 'left',
  //   slots: {
  //     default: 'opt',
  //   },
  // },
  {
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: '箱型',
    align: 'left',
    width: '150',
    field: 'boxType',
    editRender: {
      name: 'dict-select',
      props: {
        default: true,
        clearable: true,
        filterable: true,
        placeholder: '请选择箱型',
        body: {type: 'boxType'},
      },
    },
  },
  {
    title: '用箱数量',
    align: 'left',
    width: '150',
    field: 'boxNum',
    editRender: {
      name: 'input',
      attrs: {type: 'number', placeholder: '请输入用箱数量'},
    },
  },
  {
    title: '温度计数量',
    align: 'left',
    width: '150',
    field: 'tempNum',
    editRender: {
      name: 'input',
      attrs: {type: 'number', placeholder: '请输入温度计数量'},
    },
  },
  {
    title: '冰排数量',
    align: 'left',
    width: '150',
    field: 'icechopsNum',
    editRender: {
      name: 'input',
      attrs: {type: 'number', placeholder: '请输入温度计数量'},
    },
  },
]
